import React from "react";
import { Link } from "react-router-dom";

const TAB_EMPTY = {
  due: "Nothing due.",
  all: "Nothing matches this tab.",
  upcoming: "No upcoming entries.",
  past: "No past entries.",
  cancelled: "No cancelled entries.",
};

const EmptyState = ({
  activeTab,
  hasActiveFilters,
  onClearFilters,
  otherTabHint,
}) => (
  <div className="p-6">
    {hasActiveFilters ? (
      <>
        <p className="text-brand-charcoal">Nothing matches these filters.</p>
        {otherTabHint ? (
          <p className="text-sm text-brand-muted mt-2">{otherTabHint}</p>
        ) : null}
        {onClearFilters ? (
          <button
            type="button"
            onClick={onClearFilters}
            className="mt-3 text-sm text-brand-gold-ink hover:underline"
          >
            Clear filters
          </button>
        ) : null}
      </>
    ) : (
      <>
        <p className="text-brand-charcoal">
          {TAB_EMPTY[activeTab] || "Nothing here."}
        </p>
        {activeTab === "all" || activeTab === "upcoming" || activeTab === "due" ? (
          <p className="text-sm text-brand-muted mt-2">
            <Link className="underline text-brand-gold-ink" to="/tournaments">
              Find tournaments
            </Link>{" "}
            to add an event.
          </p>
        ) : null}
      </>
    )}
  </div>
);

export default EmptyState;
